/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-underscore-dangle */
import { FC, Fragment, memo, useEffect } from 'react';
import GTM from '@utils/gtm';
import Router from 'next/router';
import type { ServiceItem } from '@framework/api/types';
import getCmsLinkUrl from '@utils/get-cms-link-url';
import IconDynamic from '@components/IconDynamic';
import useUiStore, {
  getOpenModal,
  getSetModalContent,
  getSetModalView,
  getCloseModal,
} from '@stores/use-ui-store';
import * as styles from './styles';
import ServiceButton from './ServiceButton';

type Props = {
  data: ServiceItem | ServiceItem[];
  asChip?: boolean;
  lg?: boolean;
  eventType?: string;
};

// NOTE: The external link is limited to the 'Service' field in the 'Service Item' model which is a multireference link field

const ServiceBadge: FC<Props> = ({
  data,
  lg = false,
  asChip = false,
  eventType,
}) => {
  const setModalView = useUiStore(getSetModalView);
  const setModalContent = useUiStore(getSetModalContent);
  const openModal = useUiStore(getOpenModal);
  const closeModal = useUiStore(getCloseModal);

  const handleNoticeModal = (markdownContent, header): void => {
    setModalView('NOTICE_PAGE');
    setModalContent({ markdownCopy: header, markdownContent });
    openModal();
  };

  const link =
    Array.isArray(data) && data?.length > 0
      ? null
      : !Array.isArray(data) && Array.isArray(data?.internalLink)
      ? !Array.isArray(data) && data.internalLink[0]
      : !Array.isArray(data) && data?.internalLink;

  const internalHref = link
    ? getCmsLinkUrl({
        contentType: link._modelApiKey,
        pageType: link.pageType,
        slug: link.slug,
        parentSlug: link.parentCategory?.slug,
      })
    : null;

  const handleLinkClick = (event: string): void => {
    GTM.dataLayer({
      dataLayer: {
        event,
      },
    });
  };

  useEffect(() => {
    Router.events.on('routeChangeComplete', () => closeModal());

    return () => {
      Router.events.off('routeChangeComplete', () => closeModal());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return Array.isArray(data) && data?.length > 0 ? (
    <>
      {data?.map(service => {
        const serviceLink = Array.isArray(service?.internalLink)
          ? service.internalLink[0]
          : service?.internalLink;

        const internalServiceHref = serviceLink
          ? getCmsLinkUrl({
              contentType: serviceLink._modelApiKey,
              pageType: serviceLink.pageType,
              slug: serviceLink.slug,
              parentSlug: serviceLink.parentCategory?.slug,
            })
          : null;

        const modalContent =
          service?.noticeMarkdownContent || service?.decoratedMarkdownContent;

        const modalHeading = Array.isArray(service?.internalLink)
          ? service?.internalLink?.[0]?.heading || service?.copy
          : service?.internalLink?.heading || service?.copy;

        return service?.copy ? (
          <Fragment key={service?.id}>
            <div
              className={styles.detailsBox(asChip, lg)}
              data-test-id="service-badge"
            >
              <div className={styles.text(lg)}>
                <IconDynamic
                  iconName={service.iconName}
                  className={styles.iconSize}
                />
                <ServiceButton
                  isModal={Boolean(modalContent)}
                  newTab={service?.newTab}
                  internalLink={internalServiceHref}
                  externalLink={service?.externalLink?.url}
                  heading={modalHeading}
                  markdownContent={modalContent}
                  buttonLabel={service?.copy}
                  handleModal={handleNoticeModal}
                  handleEvent={() => handleLinkClick(eventType)}
                />
              </div>
            </div>
          </Fragment>
        ) : null;
      })}
    </>
  ) : (
    <>
      {!Array.isArray(data) && data?.copy ? (
        <div
          className={styles.detailsBox(asChip, lg)}
          data-test-id="not-notice-mk-service-badge"
        >
          <div className={styles.text(lg)}>
            <IconDynamic iconName={data.iconName} className={styles.iconSize} />
            <ServiceButton
              isModal={Boolean(
                data?.noticeMarkdownContent || data?.decoratedMarkdownContent
              )}
              newTab={data?.newTab}
              internalLink={internalHref}
              externalLink={data?.externalLink?.url}
              heading={
                Array.isArray(data?.internalLink)
                  ? data?.internalLink?.[0]?.heading || data?.copy
                  : data?.internalLink?.heading || data?.copy
              }
              markdownContent={
                data?.noticeMarkdownContent || data?.decoratedMarkdownContent
              }
              buttonLabel={data?.copy}
              handleModal={handleNoticeModal}
              handleEvent={() => handleLinkClick(eventType)}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default memo(ServiceBadge);
